module.exports = __webpack_public_path__ + "img/icon-10percent-sale.99d71b83.svg";